// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__3B5cg","total":"Cart_total__VlbxJ","actions":"Cart_actions__141V6","button--alt":"Cart_button--alt__FfODi","button":"Cart_button__3tQGF"};